import { Search, Upload } from "lucide-react";

import { X } from "lucide-react";

import { Link } from "lucide-react";

import { ExternalLink } from "lucide-react";
import { AdditionalOffers } from "../../../types/onboarding";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import InputForm from "../../common/Inputs/InputForm/InputForm";
import RenderEntryMethodSelection from "./RenderEntryMethodSelection";
import { TypeProduct } from "../steps/step-1-product-data";
import { useState } from "react";
import ImportProductFromLinkHeader from "./ImportProductFromLinkHeader";
import ButtonResetTypeProduct from "./ButtonResetTypeProdct";
import SearchPreviousProducts from "./SearchPreviousProducts";
import { dictionary } from "../../../utils/dictionary";
import { useAuth } from "../../../context/AuthContext";

interface RenderProductFormBumpOfferProps {
  product: AdditionalOffers;
  handleBumpOfferChange: (field: string, value: string) => void;
  handleImageUpload: () => void;
  handlePreviousBumpOfferSelect: (product: any) => void;
  previousProducts: any[];
  isPreviousProductsLoading: boolean;
}
export default function RenderProductFormBumpOffer({
  product,
  handleBumpOfferChange,
  handleImageUpload,
  handlePreviousBumpOfferSelect,
  previousProducts,
  isPreviousProductsLoading }: RenderProductFormBumpOfferProps) {
  const [typeProduct, setTypeProduct] = useState<TypeProduct>(TypeProduct.NONE);
  const { language } = useAuth();

  const handleTypeProductChange = (type: TypeProduct) => {
    setTypeProduct(type);
  };

  const handlePreviousProductSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const productId = e.target.value;
    if (!productId) return;
    const selectedProduct = previousProducts.find(product => product.id === productId);
    if (!selectedProduct) return;
    handlePreviousBumpOfferSelect(selectedProduct);
  };


  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white">
      {typeProduct === TypeProduct.NONE && (
        <RenderEntryMethodSelection
          typeProduct={typeProduct}
          handleLinkEntry={() => handleTypeProductChange(TypeProduct.LINK)}
          handleManualEntry={() => handleTypeProductChange(TypeProduct.MANUAL)}
          handlePreviousProductSelectType={() => handleTypeProductChange(TypeProduct.PREVIOUS)}
        />
      )}



      {typeProduct === TypeProduct.LINK && (
        (
          <>
            <div className="flex justify-between items-center mb-3">
              <h4 className="font-medium">{dictionary["product-information"][language]}</h4>
              <ButtonResetTypeProduct
                onClick={() => setTypeProduct(TypeProduct.NONE)}
              />
            </div>

            <div className="bg-white rounded-lg border border-gray-200 p-4">
              <ImportProductFromLinkHeader name="order bump" />
              <input
                type="text"
                className="input"
                placeholder={dictionary["paste-product-url-placeholder"][language]}
                value={product.bumpOffer?.productLink}
                onChange={(e) => handleBumpOfferChange('productLink', e.target.value)}
              />
              <p className="text-xs text-gray-500 mt-2">
                {dictionary["product-image-automatically-imported"][language]}
              </p>
            </div>
          </>
        )
      )}


      {typeProduct === TypeProduct.MANUAL && (
        <>
          <div className="flex justify-between items-center mb-3">
            <h4 className="font-medium">Product Information</h4>
            <ButtonResetTypeProduct
              onClick={() => setTypeProduct(TypeProduct.NONE)}
            />
          </div>

          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div className="form-group">
                <label className="label">{dictionary["product-name"][language]}</label>
                <div className="w-full rounded-xl border border-gray-200 overflow-hidden">
                  <InputForm
                    name="bumpOffer-productName"
                    placeholder={dictionary["enter-product-name-placeholder"][language]}
                    value={product.bumpOffer?.productName || ''}
                    onChange={(e) => handleBumpOfferChange('productName', e.target.value)}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="label">{dictionary["price"][language]}</label>
                <div className="w-full rounded-xl border border-gray-200 overflow-hidden">
                  <InputForm
                    type="number"
                    name="bumpOffer-price"
                    placeholder={dictionary["enter-price-placeholder"][language]}
                    value={product.bumpOffer?.price || ''}
                    onChange={(e) => handleBumpOfferChange('price', e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="label">{dictionary["description"][language]}</label>
              <div className="w-full rounded-xl border border-gray-200 overflow-hidden">
                <InputForm
                  name="bumpOffer-description"
                  placeholder={dictionary["enter-description-placeholder"][language]}
                  value={product.bumpOffer?.description || ''}
                  onChange={(e) => handleBumpOfferChange('description', e.target.value)}
                />
              </div>
            </div>

            <div className="border-2 border-dashed border-emerald-200 rounded-lg p-4 flex flex-col items-center justify-center">
              {product.bumpOffer?.image ? (
                <div className="relative w-full max-w-xs">
                  <img
                    src={product.bumpOffer?.image}
                    alt="order bump product"
                    className="w-full h-48 object-contain"
                  />
                  <button
                    type="button"
                    className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1"
                    onClick={() => handleBumpOfferChange('image', '')}
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              ) : (
                <>
                  <button
                    type="button"
                    onClick={() => handleImageUpload()}
                    className="btn bg-emerald-600 text-white hover:bg-emerald-700 mb-4"
                  >
                    <Upload className="w-5 h-5 mr-2" />
                    {dictionary["upload-product-image"][language]}
                  </button>
                  <div className="flex items-center text-gray-500 text-sm">
                    <span>{dictionary["upload-an-image-of-your-product"][language]}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {typeProduct === TypeProduct.PREVIOUS && (
        <div className="">
          <div className="flex justify-end mb-4">
            <ButtonResetTypeProduct
              onClick={() => setTypeProduct(TypeProduct.NONE)}
            />
          </div>
          <div className="border border-gray-200 rounded-lg p-6 shadow-sm">
            <SearchPreviousProducts
              previousProducts={previousProducts}
              handlePreviousProductSelect={handlePreviousProductSelect}
              isPreviousProductsLoading={isPreviousProductsLoading}
            />
          </div>
        </div>
      )}
    </div>
  )
}